import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const getResult = async (query, page, rowsPerPage, type, locale, filterExplicit, timeRange) => {
  if(!query){
    return false
  }
  const { token, userID } = ''//useCurrentUser();
  try {
    const { data } = await axios.get(`${API_HOST}/search?q=${query}&type=${type}&page=${page+1}&per_page=${rowsPerPage}&locale=${locale}&sfw=${filterExplicit}&time_range=${timeRange}`,{
      headers: {
        'Authorization': 'Bearer '+token,
        'x-openindex-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
